import React, { useState } from "react";
import { colors2 } from "oolib";
import { UI_CAPTION, UI_TAG } from "oolib/dist/v2/components/Typo2";
import { Tag } from "oolib/dist/v2/components/Tags";
import { WARNING_SEVERITY_COLORS } from "../constants";

export function TransparencyPanel({ breakdown, warnings, coverageSummary }) {
  const [expanded, setExpanded] = useState(false);

  const hasContent = (breakdown?.length > 0) || (warnings?.length > 0);
  if (!hasContent) return null;

  return (
    <div style={{ marginTop: 8 }}>
      <div
        onClick={(e) => { e.stopPropagation(); setExpanded(!expanded); }}
        style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", padding: "4px 0" }}
      >
        <UI_CAPTION style={{ fontWeight: 600, color: colors2.grey50 }}>
          {expanded ? "\u25BE" : "\u25B8"} Transparency
        </UI_CAPTION>
        {warnings?.length > 0 && (
          <Tag display={`${warnings.length}`} fill="solid" size="XS" style={{ background: "#F8BC3B", color: "#fff", fontSize: 9 }} />
        )}
      </div>
      {expanded && (
        <div style={{ background: colors2.grey2, borderRadius: 8, padding: "10px 14px", display: "flex", flexDirection: "column", gap: 8, marginTop: 4 }}>
          {breakdown?.length > 0 && (
            <div>
              <UI_CAPTION style={{ fontWeight: 600, color: colors2.grey60, marginBottom: 4 }}>Data sources</UI_CAPTION>
              {breakdown.map((src, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, padding: "2px 0" }}>
                  <div style={{
                    width: `${Math.max(src.weight * 100, 5)}%`, maxWidth: "40%", height: 6,
                    borderRadius: 3, background: src.tier === "linked" ? "#3BA974" : "#F8BC3B",
                  }} />
                  <UI_TAG style={{ color: colors2.grey60 }}>
                    {src.source} — {src.customers != null ? `${src.customers} customers (${src.coveragePercent}%)` : `${src.docCount} docs (unlinked)`} — weight {Math.round(src.weight * 100)}%
                  </UI_TAG>
                </div>
              ))}
            </div>
          )}
          {warnings?.length > 0 && (
            <div>
              <UI_CAPTION style={{ fontWeight: 600, color: colors2.grey60, marginBottom: 4 }}>Warnings</UI_CAPTION>
              {warnings.map((w, i) => (
                <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 6, padding: "2px 0" }}>
                  <span style={{ color: WARNING_SEVERITY_COLORS[w.severity] || colors2.grey40, fontSize: 10, flexShrink: 0 }}>
                    {w.severity === "high" ? "\u25B2" : w.severity === "medium" ? "\u25C6" : "\u25CF"}
                  </span>
                  <UI_TAG style={{ color: colors2.grey50, lineHeight: 1.4 }}>{w.message}</UI_TAG>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
